import DesignTokens from '@tableau/design-tokens';
import { ActivitySpinnerWidget, ButtonType, ButtonWidget } from '@tableau/widgets';
import * as React from 'react';

import { Messages } from '~src/codegen/Localize';
import { CloseAndDismiss } from '~src/commonInfra/dialogs/ReactModalService';
import { ToasterService, ToastType } from '~src/commonInfra/services/ToasterService';
import { applyColor }from '~src/style/ColorService';

import { GetSiteEncryptionSingleKeyHistoryRequest, GetSiteEncryptionSingleKeyHistoryResult, IGetSiteEncryptionSingleKeyHistoryEvent } from '../serverApi/requests/GetSiteEncryptionSingleKeyHistoryRequest';
import { ExtractEncryptionKeyService } from '../services/ExtractEncryptionKeyService';
import { cellStyle, headerStyle, rowStyle, tableStyle } from '../styles/ExtractEncryptionSettingsStyles';
import { capitalizeFirstLetter, formatDate } from '../utils/ExtractEncrpytionUtils';

export interface KMSKeyHistoryTableProps {
    closeDialog: CloseAndDismiss;
    externalKeyId: string;
}

export interface KMSKeyHistoryTableState {
    isFetchingKeyHistory: boolean;
    keyHistory: IGetSiteEncryptionSingleKeyHistoryEvent[];
}

interface ColumnKey {
    name: string;
    width: string;
  }

  export function getColumnKeys(): ColumnKey[]{
    return [
      {
        name: Messages.extractEncrpytion_KeyHistory_Event_header(),
        width: '60%'
      },
      {
        name: Messages.extractEncrpytion_KeyHistory_Event_Status_header(),
        width: '10%'
      },
      {
        name: Messages.extractEncrpytion_KeyHistory_Event_Date_header(),
        width: '30%'
      }
    ];
}

export class KMSKeyHistoryTable extends React.PureComponent<KMSKeyHistoryTableProps, KMSKeyHistoryTableState> {

    constructor(props: KMSKeyHistoryTableProps) {
        super(props);
        this.state = {
            isFetchingKeyHistory: true,
            keyHistory: []
        };
    }

    public componentDidMount() {
        this.fetchKeyHistory();
    }

    public render() {
        if(this.state.isFetchingKeyHistory){
          return(
            <div>
              <div><span style={{fontWeight: 'bold'}}>{Messages.extractEncryption_KMSKeyTestConnectionDialog_UniqueKeyIdentifier()}: </span><span>{this.props.externalKeyId}</span></div>
              <br></br>
              <table style={tableStyle}>
                {this.getTableHeaders()}
                </table>
                <div data-tb-test-id style={{textAlign: 'center'}}>
                  <ActivitySpinnerWidget style={{textAlign:'center', marginTop: '30px'}} testId='test'></ActivitySpinnerWidget>
                </div>
            </div>
          );
        }else{
          return (
            <div style={{height: '300px', overflowY: 'auto'}}>
              <div><span style={{fontWeight: 'bold'}}>{Messages.extractEncryption_KMSKeyTestConnectionDialog_UniqueKeyIdentifier()}: </span><span>{this.props.externalKeyId}</span></div>
              <br></br>
              <table style={{borderCollapse: 'collapse', width: '100%'}}>
                {this.getTableHeaders()}
                {this.getTableBody()}
              </table>
              <div style={{ display: 'flex', justifyContent: 'right', position: 'absolute', bottom: '20px', right: '20px' }}>
                <ButtonWidget
                    buttonType={ButtonType.Primary}
                    testId='done-button'
                    onClick={this.props.closeDialog.close}
                    children={Messages.close()}
                />
            </div>
        </div>
          );
        }
    }

    private getTableHeaders() {
        return (
            <thead style={{position: 'sticky', top: 0, zIndex: 1, backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, 'white')}}>
              {getColumnKeys().map((header, index) => (
                <th key={index} style={{ ...headerStyle, width: header.width}}>
                  {header.name}
                </th>
              ))}
          </thead>
        );
      }

    private getTableBody() {
        return (
        <tbody>
            {this.state.keyHistory.map((event: IGetSiteEncryptionSingleKeyHistoryEvent, index: number) => (
            <tr key={index} style={rowStyle}>
                <td style={cellStyle}>
                    {event.description}
                </td>
                <td style={cellStyle}>
                    {capitalizeFirstLetter(event.postActionKeyStatus)}
                </td>
                <td style={cellStyle}>
                    {formatDate(event.eventDate)}
                </td>
            </tr>
            ))}
        </tbody>
        );
    }

    private sortKeyHistory(keyHistory: IGetSiteEncryptionSingleKeyHistoryEvent[]) {
        return keyHistory.sort((a, b) => new Date(b.eventDate).getTime() - new Date(a.eventDate).getTime());
    }

    private fetchKeyHistory() {
      this.setState({isFetchingKeyHistory: true}, () => {
        ExtractEncryptionKeyService.getSiteEncryptionSingleKeyHistory(new GetSiteEncryptionSingleKeyHistoryRequest({keyId: this.props.externalKeyId}))
        .then((response: GetSiteEncryptionSingleKeyHistoryResult) => {
            this.setState({keyHistory: this.sortKeyHistory(response.events)});
        }).catch(() => {
          ToasterService.instance.pop({ type: ToastType.Error, text: Messages.extractEncryptionTOLKeyHistoryDownloadError() });
        }).finally(() => this.setState({isFetchingKeyHistory: false}));
    });
    }
}